import { qsRequired, removeTrapFocus, trapFocus } from '../core/global'
import {UcoastEl} from "@/scripts/core/UcoastEl";

export class ToggleModal extends UcoastEl {
	static htmlSelector = 'toggle-modal'
	elements: {
		el: HTMLElement
		toggleEl: HTMLElement
	}
	constructor() {
		super();
		this.elements = this.getElements()
	}

	getElements() {
		const el = qsRequired('[el]', this)
		const toggleEl = qsRequired(`[toggle]`, this)
		return {
			el,
			toggleEl,
		}
	}
	override connectedCallback() {
		this.elements = this.getElements()
		this.elements.toggleEl.addEventListener('click', (e) => {
			e.preventDefault();
			this.open();
		});
	}

	open() {
		if (this.elements.el.classList.contains('active')) {
			return;
		}
		this.elements.el.classList.add('active');
		this.elements.toggleEl.setAttribute('aria-expanded', 'true');
		trapFocus(this, this);
		window.clickOut = () => this.close();
		window.keyOut = (e: KeyboardEvent) => {
			if (e?.code?.toUpperCase() === 'ESCAPE') {
				this.close();
			}
		};
		window.setTimeout(() => {
			document.querySelector('body')?.addEventListener('click', window.clickOut, false);
			document.addEventListener('keyup', window.keyOut, false);
		}, 1);
	}
	close() {
		this.elements.el.classList.remove('active');
		this.elements.toggleEl.setAttribute('aria-expanded', 'false');
		removeTrapFocus(this.elements.toggleEl);
		document.querySelector('body')?.removeEventListener('click', window.clickOut, false);
		document.removeEventListener('keyup', window.keyOut, false);
	}
}
